import { Icon, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import { Link } from 'react-router-dom'
import { ADMIN_ROUTE } from '../../constants/routes'

export function AdminSidebarItem() {
  return (
    <ListItemButton
      component={Link}
      to={`/${ADMIN_ROUTE}`}
      sx={{
        height: '40px',
        px: '1rem',
        borderRadius: '6px',
        '& .MuiListItemIcon-root': {
          color: (theme) => theme.palette.primary.main,
        },
        '&:hover': {
          backgroundColor: (theme) => theme.palette.action.hover,
        },
      }}
    >
      <ListItemIcon
        sx={{
          minWidth: '35px',
        }}
      >
        <Icon baseClassName='material-icons-outlined'>
          {'admin_panel_settings'}
        </Icon>
      </ListItemIcon>
      <ListItemText
        primary={'Stjórnandi'}
        primaryTypographyProps={{ fontWeight: 500 }}
      />
    </ListItemButton>
  )
}
